var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs-items',{staticClass:"pb-1",model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},_vm._l((_vm.contents),function(c,i){return _c('v-tab-item',{key:i},[_c(c.componentName,_vm._b({tag:"component"},'component',c.props,false))],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }